import { FCWithChildren } from '@types';
import React, { useState } from 'react';
import classNames from 'classnames';

import { Button, Input, InputSectionGroup } from '@components';

import { AiFillCloseCircle, AiOutlineSearch } from 'react-icons/ai';

type SearchBarWMagnifierProps = {
  input: string;
  // eslint-disable-next-line no-unused-vars
  onChangehandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearchHandler?: () => void;
  onKeyDownHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  magnifierRight?: boolean;
  placeholder?: string;
  showClearSearch?: boolean;
};

const SearchBarWMagnifier: FCWithChildren<SearchBarWMagnifierProps> = ({
  input,
  onChangehandler,
  onClearSearchHandler,
  onKeyDownHandler,
  magnifierRight = false,
  placeholder = '',
  showClearSearch = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const fieldCls = classNames(
    'search-bar-group__field',
    magnifierRight ? 'flex-row-reverse' : 'flex-row',
  );

  const onFocusHandler = () => setIsFocused(true);

  const onBlurHandler = () => setIsFocused(false);

  return (
    <InputSectionGroup className="search-bar-group">
      <InputSectionGroup.Item className="search-bar-group__item">
        <div className={fieldCls}>
          <AiOutlineSearch className="search-bar-group__icon text-xl" color="gray" />
          <div className="input-section-group__control search-bar-group__control">
            <Input
              noBorder
              name="search"
              type="text"
              value={input}
              onChange={onChangehandler}
              onKeyPress={onKeyDownHandler}
              placeholder={placeholder}
              onFocus={onFocusHandler}
              onBlur={onBlurHandler}
              className="input-section-group__inline-input search-bar-group__input"
              aria-label="Search"
            />
          </div>
          {showClearSearch && (
            <Button
              aria-label="Clear search"
              layout="link"
              className="search-bar-group__clear"
              style={{ padding: 4 }}
              onClick={typeof onClearSearchHandler === 'function' ? onClearSearchHandler : () => {}}
            >
              <AiFillCloseCircle className="text-gray-500" />
            </Button>
          )}
        </div>
      </InputSectionGroup.Item>
    </InputSectionGroup>
  );
};
export default SearchBarWMagnifier;
